import errors from './error'
import basic from './basic'

export default Object({
    ...errors,
    ...basic,
})